import cx from 'classnames';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';
import css from './SelectCard.module.scss';

interface IIconProps {
  color: 'blue' | 'gray' | 'green' | 'purple' | 'red';
  icon: ElementType;
}

const Icon = ({ color, icon: IconElement }: IIconProps) => (
  <div className={cx(css.iconContainer, css[color])}>
    <IconElement />
  </div>
);

interface ITitleProps {
  children: string;
}

const Title = ({ children }: ITitleProps) => (
  <p className={css.title}>{children}</p>
);

interface IDescriptionProps {
  children: ReactNode;
}

const Description = ({ children }: IDescriptionProps) => (
  <div className={css.description}>{children}</div>
);

export interface ISelectCardProps
  extends HTMLAttributes<HTMLDivElement | HTMLButtonElement> {
  isDisabled?: boolean;
}

const SelectCardContainer = ({
  children,
  className,
  isDisabled,
  ...rest
}: ISelectCardProps) => {
  const Component = isDisabled ? 'div' : 'button';
  return (
    <Component
      className={cx(css.selectCard, className, { [css.disabled]: isDisabled })}
      {...rest}
    >
      {children}
    </Component>
  );
};

const SelectCard = SelectCardContainer as typeof SelectCardContainer & {
  Icon: typeof Icon;
  Title: typeof Title;
  Description: typeof Description;
};

SelectCard.Icon = Icon;
SelectCard.Title = Title;
SelectCard.Description = Description;

export { SelectCard };
